module.exports = __webpack_public_path__ + "static/media/IMG_1621.438afd25.JPG";